'use client';
import LanguageSelector from '@repo/ui/src/components/LanguageSelector';
import MeaterLanguageSelectorData from './MeaterLanguageSelectorData.json';
import { classNames } from '@repo/ui/src/utils/classNames';

export interface Props {
  showLabel?: boolean;
  className?: string;
}

const MeaterLanguageSelector = ({ showLabel = false, className }: Props) => {
  const { title, regions } = MeaterLanguageSelectorData;

  return (
    <LanguageSelector
      showLabel={showLabel}
      title={title}
      regions={regions}
      className={classNames('flex items-center gap-3 text-white', className)}
    />
  );
};

export default MeaterLanguageSelector;
